<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop :showClose="false">
				<div class="container px-0">
					<div class="hand">
						<div v-if="active_product.introductory" class="discount">
							<span>
								SAVE <b>{{ active_product.introductory.discount }}%</b>
							</span>
						</div>
						<img src="@/assets/paywall/hand_with_clock.png" alt="" />
					</div>
				</div>

				<div class="container">
					<div class="title">Only now! <br />One-time offer</div>
					<div class="subtitle">Take charge of your health with Simple Premium</div>

					<Countdown :seconds="900" />

					<div class="price">
						<div class="price--new">{{ active_product.text }}/year</div>
						<div class="price--old">({{ active_product.subtitle }}/year)</div>
					</div>

					<p-button @click.prevent="handleSubmit" label="" :loading="isLoading" cls="btn-primary btn-block">
						Continue
					</p-button>

					<a @click.prevent="handleSkip" href="" class="btn btn-block btn-link">Not now</a>
				</div>
			</SafeAreaTop>

			<Alert
				:isOpen="showRestoreSuccessAlert"
				title="You are all set"
				text="Your purchase was successful."
				@onClose="onCloseRestoreSuccessAlert"
			/>

			<Alert
				:isOpen="showRestoreErrorAlert"
				title="Purchase Error"
				text="There was an error while making this purchase. Please try again later."
				@onClose="onCloseRestoreErrorAlert"
			/>
		</template>

		<template v-slot:footer>
			<div class="container">
				<div class="links">
					<a @click.prevent="terms" href="">Terms</a>
					<span></span>
					<a @click.prevent="privacy" href="">Privacy</a>
					<span></span>
					<a @click.prevent="handleRestore" href="">Restore</a>
				</div>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import PButton from '@/components/Button'
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import Alert from '@/components/Alert'
import Countdown from '@/components/Countdown'
import { useStore } from 'vuex'
import { computed, ref } from '@vue/reactivity'
import useApi from '@/composition/api.js'
import { inject, watch } from '@vue/runtime-core'
import useConfig from '@/composition/config.js'

export default {
	components: {
		Page,
		PButton,
		SafeAreaTop,
		Alert,
		Countdown
	},

	setup() {
		const store = useStore()
		const api = useApi()
		const amplitude = inject('amplitude')
		const config = useConfig()

		const { terms, privacy } = api

		let isLoading = computed(() => store.state.isLoading)

		const products = computed(() => {
			return store.getters['products/getData']([
				{
					id: 'simple_high_full_price_subscription_12_months',
					text: '[introductory_price]',
					subtitle: '[price]'
				}
			])
		})

		let active_product = ref(products.value[0])
		watch(products, () => {
			active_product.value = products.value[0]
		})

		const close = (Status = 'Close') => {
			amplitude.logEvent('Paywall - Close', {
				Layout: config.get({ key: 'layout', default_value: 'Countdown' }),
				From: store.getters['getSource'],
				Step: 'Paywall',
				Status
			})
			api.close()
		}

		const Purchase = (product) => {
			api.purchase({
				productId: product.id,
				onFinish: () => {
					amplitude.logEvent('Paywall - Done', {
						Layout: 'Workbooks',
						From: store.getters['getSource'],
						Step: 'Paywall',
						ProductId: product.id,
						Status: 'Subscribe'
					})
					close('Subscribe')
				},
				onError: () => {
					console.log('error')
				},
				onCancel: () => {
					// showPaywallCancelPrompt.value = true
				},
				closeOnSuccess: false
			})
		}

		const handleSubmit = () => {
			Purchase(active_product.value)
		}

		let showRestoreSuccessAlert = ref(false)
		let showRestoreErrorAlert = ref(false)
		const handleRestore = () => {
			api.restore({
				closeOnSuccess: false,
				onFinish: () => {
					showRestoreSuccessAlert.value = true
				},
				onFail: () => {
					showRestoreErrorAlert.value = true
				}
			})
		}

		const handleSkip = () => {
			close()
		}

		const onCloseRestoreSuccessAlert = () => {
			showRestoreErrorAlert.value = false
			close('Restore')
		}

		const onCloseRestoreErrorAlert = () => {
			showRestoreErrorAlert.value = false
		}

		return {
			handleSubmit,
			handleRestore,
			handleSkip,
			isLoading,
			terms,
			privacy,
			showRestoreSuccessAlert,
			showRestoreErrorAlert,
			onCloseRestoreSuccessAlert,
			onCloseRestoreErrorAlert,
			active_product
		}
	}
}
</script>

<style lang="scss" scoped>
.hand {
	max-width: 75%;
	margin-left: auto;
	padding-top: 4vh;
	position: relative;
}
.title {
	font-size: 2rem;
	font-weight: bold;
	color: #3b3c57;
	line-height: 1.2;
	text-align: center;
	text-transform: uppercase;
}

.subtitle {
	color: #3b3c57;
	text-align: center;
	font-size: 1.1rem;
	margin-top: 0.5rem;
	line-height: 1.3;
}

.px-0 {
	padding: 0;
}

.price {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	font-size: 1.2rem;

	&--old {
		color: red;
		margin-left: 0.5rem;
		text-decoration: line-through;
	}
}

.btn-link {
	font-weight: 400;
	margin-top: 0.3rem;
	font-size: 1rem;
}

.links {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1.4rem;
	flex-wrap: wrap;

	span {
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: #3b3c57;
		margin: 2px 12px;
		opacity: 0.5;
	}

	a {
		text-decoration: none;
		color: #3b3c57;
		font-size: 0.9rem;
		display: block;
		margin: 2px 0;
	}
}

.discount {
	position: absolute;
	z-index: 1;
	top: 2rem;
	left: -1.6rem;
	background-color: #93bc1f;
	border-radius: 50%;
	width: 6.4rem;
	height: 6.4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	text-align: center;
	line-height: 1.2;
	font-size: 1.4rem;

	span {
		display: block;
	}

	b {
		display: block;
		font-weight: 500;
	}
}
</style>
